/**
 * SampleNavigator Component
 * Navigacija kroz sample recorde
 */

import {
  Box,
  Typography,
  TextField,
  IconButton,
} from '@mui/material';
import { ChevronRight as ChevronIcon } from '@mui/icons-material';

interface SampleNavigatorProps {
  sampleIndex: number;
  onSampleIndexChange: (index: number) => void;
  totalSamples: number;
  totalRecords: number;
}

export function SampleNavigator({
  sampleIndex,
  onSampleIndexChange,
  totalSamples,
  totalRecords,
}: SampleNavigatorProps) {
  return (
    <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
      <Typography variant="body2">Prikaži artikl:</Typography>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <IconButton
          size="small"
          disabled={sampleIndex === 0}
          onClick={() => onSampleIndexChange(Math.max(0, sampleIndex - 1))}
        >
          <ChevronIcon sx={{ transform: 'rotate(180deg)' }} />
        </IconButton>

        <TextField
          size="small"
          type="number"
          value={sampleIndex + 1}
          onChange={(e) => {
            const val = parseInt(e.target.value) - 1;
            if (val >= 0 && val < totalSamples) {
              onSampleIndexChange(val);
            }
          }}
          inputProps={{
            min: 1,
            max: totalSamples,
            style: { width: 50, textAlign: 'center' },
          }}
          sx={{ width: 80 }}
        />

        <Typography variant="body2">/ {totalSamples}</Typography>

        <IconButton
          size="small"
          disabled={sampleIndex >= totalSamples - 1}
          onClick={() => onSampleIndexChange(Math.min(totalSamples - 1, sampleIndex + 1))}
        >
          <ChevronIcon />
        </IconButton>
      </Box>

      <Typography variant="caption" color="text.secondary">
        (od {totalRecords} ukupno u feedu)
      </Typography>
    </Box>
  );
}
